import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
import IconCancel from '@mui/icons-material/Cancel';
import {
    Button,
    DateInput,
    SaveButton,
    SimpleForm,
    TextInput,
} from 'react-admin';

import ThumbnailInput from '@src/custom/image_input/thumbnail_input';

import Moment from 'moment';

const EditAttachmentForm = (props) => {
    const { attachment, updating, onCancel, onSubmit, hideThumbnail } = props;

    return (
        <SimpleForm
            record={attachment}
            toolbar={
                <Toolbar
                    disableGutters
                    sx={{ justifyContent: 'flex-end' }}
                >
                    <Button
                        sx={{ marginLeft: 2 }}
                        label="ra.action.cancel"
                        disabled={updating}
                        onClick={onCancel}
                    >
                        <IconCancel />
                    </Button>
                    <SaveButton
                        sx={{ marginLeft: 2 }}
                        saving={updating}
                    />
                </Toolbar>
            }
            onSubmit={onSubmit}
        >
            <Grid container sx={{ width: '100%' }}>
                <Grid size={12}>
                    <TextInput
                        fullWidth
                        required
                        label="Title"
                        source="display_name"
                    />
                </Grid>
                <Grid size={12}>
                    <DateInput
                        fullWidth
                        label="Expiration Date"
                        source="expired_at"
                        parse={(v) => Moment(v).toISOString()}
                    />
                </Grid>
                {
                    !hideThumbnail &&
                    <Grid size={{ xs: 12, md: 4 }}>
                        <ThumbnailInput label="Thumbnail" source="thumbnail" />
                    </Grid>
                }
            </Grid>
        </SimpleForm>
    );
};

EditAttachmentForm.propTypes = {
    attachment: PropTypes.object.isRequired,
    updating: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    hideThumbnail: PropTypes.bool,
};

export default EditAttachmentForm;
